import employesData from './shared/state';

export default {
  modules: {
    employesData,
  },
};
